<template>
    <!-- This component is on the select tyres page for the individual tyre cards -->
    <div class="card tyre border-0 tyre-column">
        <div class="card-header border-0 p-0">
            <!-- Tyre banners for this tyre -->
            <tyre-banners
                v-if="showBanner"
                :banners="banners"
                :tyre="tyre"
            ></tyre-banners>
            <div v-else-if="payWithPaypal">
                <div class="bg-light p-2 text-center pay-in-3 align-items-center d-flex justify-content-center">
                    <span class="d-inline-block">Pay in 3 with</span
                    ><img
                        class="ms-2 d-inline-block"
                        :src="this.baseUrl + '/assets/img/generic_images/paypal_logo.png'"
                        alt="Paypal logo"
                    />
                </div>
            </div>
        </div>
        <div
            class="card-body border d-flex flex-column"
            :class="[
                tyreBorder + '-border',
                showBanner ? 'rounded-bottom' : '',
                featured ? 'featured' : '',
            ]"
        >
            <div class="text-center row">
                <div class="col-3">
                    <img
                        :src="tyre.brand_image_url"
                        class="brand-image img-fluid mb-2"
                        :alt="tyre.brand + ' logo'"
                        height="40"
                        @error="replaceBrandByDefault"
                    />
                    <div class="tyre-image">
                        <a :href="this.baseUrl + tyre.tyre_info_url">
                            <img
                                :src="tyre.image_url"
                                class="img-fluid"
                                :alt="
                                    tyre.brand + ' ' + tyre.tyre_range + ' logo'
                                "
                                height="135"
                                @error="replaceByDefault"
                            />
                        </a>
                        <fitments
                            :fitments="tyre.fitments"
                            :fitment-summary="false"
                        ></fitments>
                    </div>
<!--                    <div class="tyre-info-badge" v-if="inBasket || inFeatured">-->
<!--                        <div-->
<!--                            class="d-block badge bg-navy text-light fw-bold"-->
<!--                            v-if="inFeatured"-->
<!--                        >-->
<!--                            <i class="fas fa-star me-2"></i>-->
<!--                            <span>Featured</span>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <div class="col-5 text-start pe-0">
                    <b>{{ tyre.brand }}</b>
                    <div class="tyre-size v-100">
                        <p class="mb-0">{{ tyre.tyre_range }}</p>
                        <p class="mb-0">
                            {{ tyre.description }}
                        </p>
                    </div>
                    <specialisms :tyre="tyre"></specialisms>
                    <rating-labels
                        :fuel="tyre.fuel"
                        :wet="tyre.wet"
                        :decibels="tyre.decibels"
                        :noise-rating="tyre.noise_rating"
                    ></rating-labels>
                    <div class="row">
                      <template v-if="tyre.tyre_video?.length > 0">
                        <div class="col-12 col-xxl-6">
                          <checkatyre-tyre-video
                              custom-style="etyres"
                              :multi-video="true"
                              .tyre-video-details="tyre.tyre_video"
                              :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                          ></checkatyre-tyre-video>
                        </div>
                      </template>
                      <div class="col-12 col-xxl-6">
                        <new-awards
                            :awards="tyre.award_badges"
                            :tyre-url="tyre.tyre_info_url"
                        ></new-awards>
                      </div>
                    </div>
                    <div class="mt-2">
                        <reviews
                            :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                            mobile-align="left"
                        ></reviews>
                    </div>
                </div>
                <div class="col-4 text-start">
                    <b class="price">&pound;{{ tyre.display_price }}</b>
                    <p class="mb-0 per">Per tyre</p>
                    <select
                        name="quantity"
                        id="quantity"
                        class="form-control my-2"
                        v-model="quantity"
                    >
                        <option v-for="index in 5" :key="index" :value="index">
                            {{ index }}
                        </option>
                    </select>
                    <button
                        class="btn btn-primary w-100"
                        :class="buttonColour"
                        @click="
                            this.$parent.$parent.addTyreToBasket(
                                tyre.st_code,
                                quantity
                            )
                        "
                    >
                        {{ tyreText }}
                    </button>
                    <earliest-fitting
                        v-if="
                            this.$parent.$parent.updatedPostcode &&
                            this.$parent.$parent.homeDelivery == false
                        "
                        :fitting-today="tyre.fitting_today"
                        :fitting-tomorrow="tyre.fitting_tomorrow"
                        :earliest-fitting-date="tyre.earliest_fitting_date"
                        :postcode="postcode"
                    ></earliest-fitting>
                </div>
            </div>
        </div>
        <div
            v-if="featured"
            class="card-footer text-center"
            :class="tyre.view_class"
        >
            <b class="d-inline-block"
                >{{ tyre.view_label_1 }} {{ tyre.view_label_2 }}</b
            >
            <a class="d-inline-block ms-3" :href="'/' + tyre.link">{{
                tyre.link_text
            }}</a>
        </div>
    </div>
</template>

<script>
    import tyre from "@shared/mixins/tyre";
    export default {
        props: ["tyre", "banners", "basket", "postcode", "featured", "payWithPaypal"],
        components: {},
        mixins: [tyre],
        data() {
            return {
                quantity: this.$parent.$parent.quantity,
                featuredTopSpotFlag: false,
            };
        },
        methods: {},
        computed: {},
    };
</script>
<style lang="scss" scoped>
    .tyre {
        .pay-in-3 {
            font-size: 18px;
            color: #203674;
        }
        .card-header {
            background-color: transparent;
        }
        .card-body {
            position: relative;
            padding-bottom: 10px;

            @media (max-width: 768px) {
                padding-bottom: 1.6em;
            }

            &.featured {
                border-bottom-left-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
            }
            .tyre-image {
                position: relative;
                height: 130px;
            }
            .price {
                font-size: 22px;
            }
            .per {
                font-size: 12px;
            }
            .tyre-info-badge {
                position: absolute;
                bottom: 5px;
                left: -5px;
                text-align: left;
                div:nth-of-type(2) {
                    margin-top: 5px;
                }
                .fa-star {
                    color: #ffc107;
                }
            }
        }
    }
</style>